interface Article {
	imageSrc: string
	title: string
	date: string
	tag: string
	href: string
}

interface Publication {
	title: string
	href: string
}

export const articleList: Article[] = [
	{
		imageSrc: 'materials-article.png',
		title: 'Как эффективнее обрабатывать входящие заявки на кредит',
		date: '14 сентября',
		tag: 'Советы',
		href: 'https://journal.credit.club/tpost/rffoa3mju9-kak-effektivnee-obrabativat-vhodyaschie',
	},
	{
		imageSrc: 'materials-article2.png',
		title: 'Почему заложить квартиру в объекте культурного наследия бывает сложно ',
		date: '14 сентября',
		tag: 'Кейсы',
		href: 'https://journal.credit.club/tpost/1irhe49ic2-pochemu-zalozhit-kvartiru-v-obekte-kultu',
	},
]

export const publicationList: Publication[] = [
	{
		title: 'Как монетизировать старых клиентов в кризис',
		href: 'https://exbico.ru/case/kak-brokeru-privlekat-staryx-klientov-v-krizis/',
	},
	{
		title: 'Контроль качества и маркетинговые инсайты',
		href: 'https://exbico.ru/case/kontrol-kachestva/',
	},
	{
		title: 'Как быстро запустить реферальную программу',
		href: 'https://exbico.ru/case/kak-bystro-zapustit-referalnuyu-programmu/',
	},
	{
		title: 'Больше информации о компании — больше клиентов',
		href: 'https://exbico.ru/case/bolshe-informacii-o-kompanii/',
	},
]
